import { useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import { computed, toJS } from "mobx";

import { Calendar } from "primereact/calendar";
import { FloatLabel } from "primereact/floatlabel";
import { Tag } from "primereact/tag";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import { handleCopyBuffer, getStatusTag } from "@utils";

import "./style.scss";

import moment from "moment";
import ButtonUI from "@UI/ButtonUI";

const BucketDetail = inject("mainStore")(
    observer(({ mainStore, changeableData }) => {
        const offer = computed(() => mainStore.getMainStore("suggest.offers_suggest")).get();
        const [dates, setDates] = useState(null);
        const [promoIssued, setPromoIssued] = useState([]);
        const [promoFree, setPromoFree] = useState([]);
        const [offerBucket, setOfferBucket] = useState([]);

        useEffect(() => {
            if (changeableData?.code) {
                getPromoIssued();
                getPromoFree();
                getOffer();
            }
        }, []);

        const columns = [
            {
                field: "_id",
                header: "Id",
                sortable: false,
                style: { width: "10%", maxWidth: "103px", textOverflow: "ellipsis", overflow: "hidden" },
                body: (item) => (
                    <div className="id__copy cursor-pointer" onClick={(e) => handleCopyBuffer(e, item, "_id", (val) => mainStore.setMainStore("toast", { severity: "success", life: 4000, summary: `Скопировано`, detail: val }))}>
                        <span className=" text">ID</span>
                        <i className="pi pi-clone"></i>
                    </div>
                ),
                type: "text",
            },
            {
                field: "title",
                body: (item) => {
                    return <span>{item.title}</span>;
                },
                header: "Название оффера",
                type: "text",
            },

            {
                body: (item) => {
                    const tag = getStatusTag(item);
                    return <Tag severity={tag.type} icon={tag.icon} />;
                },
                header: "Статус",
                style: { width: "10%" },
                sortable: false,
            },
        ];

        const getOffer = async () => {
            const resp = await mainStore.getByUrl("/promo/offers", { filters: { bucketCode: changeableData?.code } });

            if (resp && resp.success) {
                setOfferBucket(resp.data);
            }
        };

        const getPromoIssued = async () => {
            const resp = await mainStore.getByUrl("/promo/promoVendors", { filters: { bucketCode: `${changeableData.code}`, repayed: true, rows: 5 }, sortField: "repayedAt", sortOrder: "desc" });
            if (resp && resp.success) {
                setPromoIssued(resp.data.splice(0, 5));
            }
        };

        const getPromoFree = async () => {
            const resp = await mainStore.getByUrl("/promo/onlyFetchPromoFromBucket", { bucketCode: `${changeableData.code}`, count: 5 }, "", true, true, false);

            if (resp && resp.success) {
                setPromoFree(resp.data.splice(0, 5));
            }
        };

        const handleGetActive = async () => {
            const obj = {
                bucketCode: `${changeableData.code}`,
                count: 10000,
            };

            if (dates && dates[0]) {
                obj.dateStart = moment(dates[0]).format("YYYY-MM-DD");
            }

            if (dates && dates[1]) {
                obj.dateEnd = moment(dates[1]).format("YYYY-MM-DD");
            }
            const resp = await mainStore.postByUrl("/reports/getRepayedCodesByBucket", obj);

            if (resp && typeof resp != "object") {
                const blob = new Blob([resp], { type: "text/csv;charset=utf-8;" });
                const fileName = "codes.csv";
                const elem = window.document.createElement("a");
                elem.href = window.URL.createObjectURL(blob);
                elem.download = fileName;
                document.body.appendChild(elem);
                elem.click();
                document.body.removeChild(elem);
            }
        };

        const handleGetFree = async () => {
            const resp = await mainStore.getByUrl(`/promo/onlyFetchPromoFromBucketCsv`, { bucketCode: `${changeableData.code}`, count: 10000 });

            if (resp && typeof resp != "object") {
                const blob = new Blob([resp], { type: "text/csv;charset=utf-8;" });
                const fileName = "codes.csv";
                const elem = window.document.createElement("a");
                elem.href = window.URL.createObjectURL(blob);
                elem.download = fileName;
                document.body.appendChild(elem);
                elem.click();
                document.body.removeChild(elem);
            }
        };

        return (
            <div className="bucket__detail">
                {changeableData.uploadedPromo ? (
                    <div className="header">
                        <div className="progress_bar">
                            <span>{`Выдано ${changeableData.repayedPromo.toLocaleString("ru-RU")} / Загружено ${changeableData.uploadedPromo.toLocaleString("ru-RU")}`}</span>
                            <div
                                className="green"
                                style={{
                                    width: `${(changeableData.repayedPromo / changeableData.uploadedPromo) * 100 <= 2 ? 100 : 100 - (changeableData.repayedPromo / changeableData.uploadedPromo) * 100}%`,
                                }}
                            />
                        </div>
                    </div>
                ) : null}

                {promoIssued.length ? (
                    <div>
                        <div className="header" style={{ marginBottom: "12px" }}>
                            <span>Список выданных кодов</span>
                            <div className="row">
                                <FloatLabel>
                                    <Calendar className="date" inputId="period" value={dates} onChange={(e) => setDates(e.value)} showIcon readOnlyInput placeholder="Выбрать период" dateFormat="dd.mm.yy" selectionMode="range" hideOnRangeSelection />
                                    <label htmlFor="period">Выбрать период</label>
                                </FloatLabel>
                                <ButtonUI label="Скачать выданные коды" icon="pi pi-check" outlined severity="success" onClick={handleGetActive} />
                            </div>
                        </div>

                        <div className="table">
                            <div className="table__head">
                                <span>Выданный код</span>
                                <span>Название оффера</span>
                                <span>Дата выдачи</span>
                            </div>

                            {promoIssued.map((el, idx) => {
                                const nameOffer = offer ? offer.find((i) => i._id === el.offerId) : null;

                                return (
                                    <div className={`table__body `} key={idx}>
                                        <span>{el.code}</span>
                                        <span>{nameOffer ? nameOffer.title : ""}</span>
                                        <span>{moment(el.repayedAt).format("DD.MM.YYYY")}</span>
                                    </div>
                                );
                            })}
                        </div>

                        <div className="info">
                            <i className="pi pi-times-circle icon"></i>
                            <div className="info-text">
                                <span>Обратите внимание: вы скачиваете файл с промокодами, не удаляя их!</span>
                                <span className="bold">Этот файл нельзя использовать в других корзинах!</span>
                            </div>
                            <i className="pi pi-times close"></i>
                        </div>
                    </div>
                ) : null}

                {promoFree.length ? (
                    <div>
                        <div className="header" style={{ marginBottom: "12px" }}>
                            <span>Список свободных кодов</span>
                            <ButtonUI label="Скачать свободные коды" icon="pi pi-check" outlined severity="success" onClick={handleGetFree} />
                        </div>

                        <div className="table" style={{ justifyContent: "flex-start" }}>
                            <div className="table__head">
                                <span style={{ textAlign: "start" }}>Код</span>
                            </div>
                            {promoFree.map((el, idx) => {
                                return (
                                    <div className={`table__body `} key={idx}>
                                        <span style={{ textAlign: "start" }}>{el}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                ) : null}

                {offerBucket.length ? (
                    <div style={{ marginTop: "42px" }}>
                        <div className="header" style={{ marginBottom: "12px" }}>
                            <span>Офферы в которых используется корзина</span>
                        </div>

                        <DataTable value={offerBucket} scrollable emptyMessage="Ничего не найдено" editMode="cell">
                            {columns.map((it) => (
                                <Column key={it._id} field={it.field} header={it.header} sortable={it.sortable} style={it.style} body={it.body} />
                            ))}
                        </DataTable>
                    </div>
                ) : null}
            </div>
        );
    }),
);

export default BucketDetail;
